import { Reducer } from 'redux'
import { ActionTypes, XIDR_TOUR_ACTIONS } from './types'

const initialState = {
  currentStepIndex: 0,
  isTourRunning: false,
  currentTarget: '.tour-target-verify-account',
}

type State = {
  currentStepIndex: number
  isTourRunning: boolean
  currentTarget: string
}

export const xidrTour: Reducer<State, ActionTypes> = (state = initialState, action) => {
  switch (action.type) {
    case XIDR_TOUR_ACTIONS.SET_CURRENT_STEP_INDEX: {
      return {
        ...state,
        currentStepIndex: action.currentStepIndex,
      }
    }

    case XIDR_TOUR_ACTIONS.SET_IS_TOUR_RUNNING: {
      return {
        ...state,
        isTourRunning: action.isTourRunning,
      }
    }

    case XIDR_TOUR_ACTIONS.SET_CURRENT_TARGET: {
      return {
        ...state,
        currentTarget: action.currentTarget,
      }
    }

    default:
      return state
  }
}
